// extracted by mini-css-extract-plugin
export var container = "lpImageStyles-module--container--85109";
export var container__imageDesktop = "lpImageStyles-module--container__image--desktop--93537";
export var container__imageMobile = "lpImageStyles-module--container__image--mobile--10dce";
export var container_link = "lpImageStyles-module--container_link--aad33";
export var container_padding = "lpImageStyles-module--container_padding--89bd9";